module.exports = __webpack_public_path__ + "static/media/moussaka-image.c878bae8.jpg";